import {createReducer} from '../utils/createReducer';
import {jumpToOAuth2, request} from "../utils/request";
import {Toast} from "antd-mobile";
import {comment} from "../pages/App";


const namespace: string = "comment";

const initialState = {
  commentList: [],
  readInfo: {},
};

const reducer = {
  getCommentList(state: any, action: any){
    if (action.error || action.result.error){

      {
        const params = new URLSearchParams(window.location.search);
        const notAuthorized= params.get('authorized') === 'false';
        console.log('getCommentList notAuthorized: ', notAuthorized);
        console.log('getCommentList navigator.userAgent: ', navigator.userAgent);
        if (!notAuthorized && action.result && action.result.error === "need_login_first") {
          if (/ztobox|ztbox|baohe/.test(navigator.userAgent.toLowerCase())) {
            // 为防止不明原因导致可能存在的无限跳转, 需要额外记录上次刷新时间, 如果在5秒之内, 就不再刷新
            const lastLogin = localStorage.getItem("lastLoginByComment");
            console.log("上次登录时间 -> ", lastLogin)
            if (lastLogin !== null) {
              const lastTime = parseInt(lastLogin)
              const nowDate = Date.now();
              if (nowDate - lastTime < 1000 * 5) {
                // 不跳转
                return {...state, commentList: []}
              }
            }
            const nowDate = Date.now();
            localStorage.setItem("lastLoginByComment",  "" + nowDate);
            jumpToOAuth2();
          }
        }
      }

      return {...state, commentList: []}
    }
    return {...state, commentList: formatData(action.result.comments), readInfo: action.result.readInfo}
  },

  onCommentErr(state: any){
    Toast.fail("评论失败！", 2);
    return state
  },

  onDeleteErr(state: any){
    Toast.fail("删除失败！", 2);
    return state
  },

  onPraise(state: any, action: any){
    if (action.action.commentId === 0){
      return state
    }
    let commentList: comment[] = state.commentList.slice();
    commentList.find(item => {
      if (item.id === action.action.commentId){
        item.praised = true;
        item.praise_num = item.praise_num + 1;
        return true
      }
      return false
    });
    return {...state, commentList }
  },
};

export default createReducer(initialState, reducer, namespace)

export function makePraise(action: any): Actions {
  return {
    type: "comment/onPraise",
    promise: request(`/praise?commentId=${action.commentId}`, {method: "post"}),
    action
  }
}
export function makeComment(action: any): Actions {
  return {
    types: ["comment/onCommentLoad", "comment/onCommentSuc", "comment/onCommentErr"],
    promise: request("/put_comment", {method: "post", body: action}),
    action
  }
}
export function deleteComment(action: any): Actions {
  return {
    types: ["comment/onDeleteLoad", "comment/onCommentSuc", "comment/onDeleteErr"],
    promise: request("/del_comment", {method: "post", body: action})
  }
}
export function stickComment(action: any): Actions{
  return {
    types: ["comment/onStickLoad", "comment/onCommentSuc", "comment/onStickErr"],
    promise: request(`/stick_comment`, {method: "post", body: action})
  }
}

function formatData<T extends comment>(data: T[]): T[]{
  let newData: T[] = [];

  for (let item of data){
    if (!item.reply_id){
      newData.push(item)
    } else {
      newData.find(i => {
        if (i.id === item.reply_id){
          i.reply = i.reply ?[...i.reply, item] : [item];
          return true
        }
        return false
      })
    }
  }

  return newData;
}



// WEBPACK FOOTER //
// ./src/reducers/comment.ts